module.exports = __webpack_public_path__ + "img/CS48Q-中_18.eb7af3ad.jpg";